import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import { ButtonProps } from "ds/components/Button";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { NamedWebhooksIntegration } from "types/generated";
import { AccessResult } from "utils/access";

type WebhookOptionDropdownProps = {
  id: NamedWebhooksIntegration["id"];
  hasManageAccess: AccessResult;
  dotSize?: ButtonProps["size"];
  onDeleteClick: () => void;
};

const WebhookOptionDropdown = (props: WebhookOptionDropdownProps) => {
  const { dotSize, id, onDeleteClick, hasManageAccess } = props;

  const showActionButtons = hasManageAccess.result || !!hasManageAccess.message;

  return (
    <DropdownMenuEllipsis tooltip="Webhook actions" dotsSize={dotSize}>
      <CopyFieldDropdownMenuItem title="Copy webhook ID" value={id} />
      {showActionButtons && (
        <>
          <DropdownMenuItem
            href={`/webhook/${id}/edit`}
            isDisabled={!hasManageAccess.result}
            tooltip={hasManageAccess.message}
          >
            Edit webhook
          </DropdownMenuItem>
          <DropdownMenuItem
            onAction={onDeleteClick}
            danger
            isDisabled={!hasManageAccess.result}
            tooltip={hasManageAccess.message}
          >
            Delete webhook
          </DropdownMenuItem>
        </>
      )}
    </DropdownMenuEllipsis>
  );
};

export default WebhookOptionDropdown;
